'use client';

import React from "react";
import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function CtaSection() {
  return (
    <section id="cta" className="bg-secondary text-foreground">
      <div className="container mx-auto px-4 py-10 text-center sm:py-16">
        <h2 className="font-headline text-3xl tracking-[-0.04em] leading-[1.1] sm:text-4xl text-black font-semibold">
          Sua hora médica vale mais que tarefas repetitivas.
        </h2>
        <div className="mt-8 mx-auto max-w-3xl border-t border-foreground/20 pt-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-left">
                <div>
                    <h3 className="font-semibold text-lg tracking-tight">Dados Objetivos:</h3>
                    <p className="mt-2 text-foreground/90 tracking-tight">
                        4 horas/dia = 88 horas/mês desperdiçadas. 88 horas x valor da sua hora médica = prejuízo mensal direto. Uma única cirurgia adicional paga o investimento do sistema.
                    </p>
                </div>
                <div>
                    <h3 className="font-semibold text-lg tracking-tight">Conclusão Lógica:</h3>
                    <p className="mt-2 text-foreground/90 tracking-tight">
                        Se faz sentido financeiramente e clinicamente, implemente hoje.
                    </p>
                </div>
            </div>
        </div>
        <div className="mt-12">
          <Button size="lg" asChild className="bg-green-300 text-black hover:bg-green-400">
            <Link href="#">
              Ativar MedFollow agora
              <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
